<template>
  <div class="flex flex-col lg:flex-row w-full bg-gray-200 h-screen">
    <div class="layout-auth w-full lg:w-6/12 flex-1">
      <div class="layout-auth-container">
        <div class="layout-auth-content">
          <div class="mb-4">
            <img
              src="../assets/my-ricoma.svg"
              alt="ricoma logo"
              class="mt-12 lg:mt-0 mb-4 lg:mb-6 w-2/4 mx-auto lg:w-9/12"
            />
            <div class="text-white text-sm text-center max-w-sm mx-auto mb-3">
              <div class="text-ricoma-orange-300 font-bold">
                Welcome to Your Ricoma Customer Portal!
              </div>
              <span
                >This portal is your one-stop hub for scheduling training sessions, watching
                tutorial videos, accessing product manuals, downloading software, and more.</span
              >
            </div>
          </div>
          <slot></slot>
          <div
            class="mb-12 lg:mb-0 mt-5 text-white text-sm font-semibold text-center max-w-lg mx-auto"
          >
            <span>Your username is the email address you used when purchasing your machine. </span>
            <span class="text-ricoma-orange-300"
              >If you don’t remember your password, simply click “Forgot Password” above and enter
              that same email address to reset it.</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="lg:w-6/12 realtive block relative">
      <a
        href="https://www.youtube.com/watch?v=xgMDe5sMNTw"
        target="_blank"
        class="block h-full w-full"
      >
        <div class="block h-full w-full">
          <div class="login-ad-side p-4 md:px-24 md:py-32 lex flex-col items-center justify-center">
            <div class="max-w-3xl mx-auto">
              <!-- <img src="../assets/end-of-year-title.png" class="mb-12" /> -->
              <!-- <p class="text-xl text-white mb-8 text-center"> -->
              <!--   <span class="text-yellow"> -->
              <!--     Save up to 70% + HUGE deals on embroidery machines and DTF printers!</span -->
              <!--   > -->
              <!--   Enjoy free shipping on embroidery machines up to $1,500 and on DTF printers up to -->
              <!--   $800. Hurry—once inventory is gone, so is this pricing! -->
              <!-- </p> -->
              <!-- <div class="text-center"> -->
              <!--   <button class="login-ad-side-button">Shop Now</button> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="lg:w-6/12 realtive hidden">
      <div class="login-ad-side p-4 md:p-24">
        <div>
          <p
            class="text-2xl lg:text-4xl xl:text-5xl text-center lg:text-left text-white font-bold lg:max-w-lg mb-4 lg:mb-8"
          >
            Unlock Exclusive Savings for DecoSummit 2024!
          </p>
          <p
            class="text-lg lg:text-xl text-white mb-4 lg:mb-8 font-semibold max-w-lg text-center lg:text-left"
          >
            Access your
            <span class="text-black p-1 font-bold" style="background-color: #fff000">20% OFF</span>
            discount code by signing into your account now! Don't miss out on this limited time
            offer!
          </p>
          <div class="mx-w-lg text-center lg:text-right">
            <img
              src="../assets/decosummit-white.svg"
              alt="ricoma logo"
              class="mx-auto lg:mr-0 lg:ml-auto"
            />
            <p class="text-sm text-white mb-1">August 21-23, 2024</p>
            <p class="text-sm text-white mb-1">Hilton Miami Airport Blue Lagoon Hotel</p>
            <p class="text-sm text-white">5101 Blue Lagoon Drive, Miami, FL 33126</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLayoutAuth',
};
</script>
